var React = require('react');

function FullScreen (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentcolor","fillRule":"evenodd","d":"M6.003 9.29v3.605a1.5 1.5 0 1 1-3 0V5.437a1.5 1.5 0 0 1 1.5-1.5h7.458a1.5 1.5 0 1 1 0 3H7.893l5.813 5.813a1.5 1.5 0 0 1-2.122 2.122L6.004 9.29zm18.964 14.405V20.09a1.5 1.5 0 1 1 3 0v7.458a1.5 1.5 0 0 1-1.5 1.5H19.01a1.5 1.5 0 0 1 0-3h4.068l-5.813-5.813a1.5 1.5 0 1 1 2.121-2.121l5.581 5.58zM8.291 25.982h3.604a1.5 1.5 0 1 1 0 3H4.437a1.5 1.5 0 0 1-1.5-1.5v-7.458a1.5 1.5 0 0 1 3 0v4.069l5.813-5.813a1.5 1.5 0 0 1 2.122 2.121l-5.581 5.58zM22.68 7.003h-3.604a1.5 1.5 0 0 1 0-3h7.457a1.5 1.5 0 0 1 1.5 1.5v7.458a1.5 1.5 0 1 1-3 0V8.893l-5.813 5.813a1.5 1.5 0 0 1-2.121-2.122l5.58-5.58z"}));
}

FullScreen.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = FullScreen;

FullScreen.default = FullScreen;
